module.exports = __webpack_public_path__ + "static/media/user-inverted.f0b97d67.svg";